export const RETIREMENT_EMAIL_SUBJECT = "Official Notification of Statutory Retirement | MINEDUC";

export const RETIREMENT_NOTIFICATION = `Dear {firstName} {lastName},

This letter serves as an official notification from the Ministry of Education, Republic of Rwanda, regarding your statutory retirement in accordance with the laws governing public service employment.

As per our records, you are currently {age} years old and serving at {school}. In line with the provisions of the Law N° 017/2020 of 07/10/2020 governing the Statute of Public Service, specifically Article 71, the mandatory retirement age for public servants in Rwanda is sixty-five (65) years. Upon reaching this age, public servants are required to retire from active service.

We wish to express our sincere appreciation for your dedicated service and invaluable contribution to the education sector. Your commitment has played a significant role in shaping the future of our nation.

Retirement Process and Next Steps:

In accordance with the above-mentioned law, the following steps are to be undertaken to ensure a smooth transition:

Preparation of Retirement Documentation:
Please begin assembling the necessary documents, including:
National Identification Card (ID)
Complete service records
Updated Curriculum Vitae (CV)
Recent passport-sized photographs

Consultation with School Administration:
Kindly arrange a meeting with your Head Teacher to:
Discuss the retirement timeline and transition plan
Facilitate knowledge transfer and handover of responsibilities
Address any outstanding administrative matters

Engagement with Rwanda Social Security Board (RSSB):
You are advised to contact the RSSB to initiate your pension benefits process. This includes:
Submission of required documentation
Calculation of pension entitlements
Clarification of payment procedures

Important Dates and Information:

Last working day: [To be determined in consultation with your Head Teacher]
Pension application deadline: At least three (3) months prior to your official retirement date, as recommended by RSSB guidelines
Exit interview: [To be scheduled]

For further assistance, the Human Resources Department of the Ministry of Education remains at your disposal to provide guidance and support throughout this process. You may contact us via:

Email: retirement@mineduc.gov.rw
Phone: +250 788 XXX XXX
Office hours: Monday to Friday, 8:00 AM – 5:00 PM

We thank you once again for your exemplary service to the Republic of Rwanda. Your legacy will continue to inspire and guide future generations.

Yours faithfully,
Ministry of Education
Republic of Rwanda`;
